import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDownloadURL, ref, uploadBytes, getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { toast } from "react-toastify";
import {
    GoogleAuthProvider,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
    getAuth,
    updateProfile,
    FacebookAuthProvider,
    sendEmailVerification,
} from "firebase/auth";
import { query, getDocs, collection, where, addDoc, doc, getFirestore, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_apiKey,
    authDomain: process.env.REACT_APP_authDomain,
    projectId: process.env.REACT_APP_projectId,
    storageBucket: process.env.REACT_APP_storageBucket,
    messagingSenderId: process.env.REACT_APP_messagingSenderId,
    appId: process.env.REACT_APP_appId,
    measurementId: process.env.REACT_APP_measurementId

};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const secondaryAuth = getAuth(app);
const storage = getStorage(app);
const db = getDatabase(app);
const firestoredb = getFirestore(app);

export const getmapdata = async () => {
    var map = []
    let count = 0

    const querySnapshot = await getDocs(collection(firestoredb, "map"))
    querySnapshot.forEach((doc) => {
        count++
        if (count < 10) {
            map.push(
                {
                    id: `0${count}`,
                    numRows: 19,
                    numCols: 22,
                    mapdata: doc.data(),
                },
            )
        } else {
            map.push(
                {
                    id: `${count}`,
                    numRows: 19,
                    numCols: 22,
                    mapdata: doc.data(),
                },

            )
        }
    });
    return map
}
//Secondary Firebase
// const secondary_app = initializeApp(firebaseConfig);
// const auth = getAuth(secondary_app);
// const secondary_storage = getStorage(secondary_app);
// const secondary_db = getDatabase(secondary_app);
// const secondary_firestoredb = getFirestore(secondary_app);

// const currentUsera = "";
// export const AuthContext = createContext();

// onAuthStateChanged(auth, (currentUser) => {
//     if (currentUser) {
//         // console.log("logged in " + currentUser.displayName);
//         // setAbc(currentUser.displayName);
//     } else {
//     }
// });

// export const useAuthState = () => {
//     const auth = useContext(AuthContext);
//     return { ...auth, isAuthenticated: auth?.user != null };
// };

// export const useAuth = () => {
//     const [currentUser, setCurrentUser] = useState();
//     useEffect(() => {
//         const unsub = onAuthStateChanged(auth, (user) => setCurrentUser(user));
//         return unsub;
//     }, []);
//     return currentUser;
// };

export const uploadImg = async (image, currentUser) => {
    // const currentUser = useAuth();
    let success = false;
    const imageRef = ref(storage, currentUser.uid + "image");
    const snapshot = await uploadBytes(imageRef, image);

    await getDownloadURL(imageRef)
        .then((res) => {
            console.log(res);
            success = true;
            updateProfile(currentUser, { photoURL: res });
        })
        .catch((err) => {
            console.log(err);
            success = false;
        });

    return success;
    // window.location.reload();
};

export const uploadImgPlot = async (image, currentUser) => {
    // const currentUser = useAuth();
    let success = false;
    let downloadurl;
    const imageRef = ref(storage, currentUser.uid + "image" + Date.now());
    const snapshot = await uploadBytes(imageRef, image);

    await getDownloadURL(imageRef)
        .then((res) => {
            downloadurl = res;
            success = true;
        })
        .catch((err) => {
            console.log(err);
            success = false;
        });

    return downloadurl;
    // window.location.reload();
};

export const RegisterFb = async () => {
    const provider = new FacebookAuthProvider();
    // // const history = useHistory();
    // try {
    //     const user = await signInWithPopup(auth, provider)
    //     console.log(user);
    // } catch (err) {
    //     console.error(err);
    //     alert(err.message);
    // }
    console.log(provider);

    signInWithPopup(auth, provider)
        .then(async (result) => {
            // The signed-in user info.
            console.log(result);
            const user = result.user;
            const q = query(collection(firestoredb, "Users"), where("uid", "==", user.uid));
            const docs = await getDocs(q);
            if (docs.docs.length === 0) {
                await setDoc(doc(firestoredb, "Users", user.uid), {
                    uid: user.uid,
                    email: user.email,
                    isApproved: true,
                    isAdmin: false,
                    firstName: "",
                    lastName: "",
                    dateOfBirth: "",
                    phoneNumber: ""
                })
            }

            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            const credential = FacebookAuthProvider.credentialFromResult(result);
            const accessToken = credential.accessToken;

            // IdP data available using getAdditionalUserInfo(result)
            // ...
        })
        .catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.customData.email;
            // The AuthCredential type that was used.
            const credential = FacebookAuthProvider.credentialFromError(error);
            console.log(error);
            // ...
        });
}

const signInWithGoogle = async () => {
    const googleProvider = new GoogleAuthProvider();
    console.log(googleProvider);
    try {
        const res = await signInWithPopup(auth, googleProvider);
        const user = res.user;
        const q = query(collection(firestoredb, "Users"), where("uid", "==", user.uid));
        const docs = await getDocs(q);
        if (docs.docs.length === 0) {
            await setDoc(doc(firestoredb, "Users", user.uid), {
                uid: user.uid,
                email: user.email,
                isApproved: true,
                isAdmin: false,
                firstName: "",
                lastName: "",
                dateOfBirth: "",
                phoneNumber: "",
                bindedWallet: ""

            })
        }
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};
const logInWithEmailAndPassword = async (email, password) => {
    return new Promise((resolve, reject) => {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCred) => {
                localStorage.isSigninSuccess = true;
                resolve({ success: true, userCred: userCred })
            })
            .catch((e) => {
                toast.error(" User and Password not correct", {
                    toastId: "loginError",
                });
                reject({ success: false, error: e })
            });
    })
};
const registerWithEmailAndPassword = async (email, password, date) => {

    let error = false;
    await createUserWithEmailAndPassword(auth, email, password)
        .then(async (res) => {
            const user = res.user;

            sendEmailVerification(res.user).then(res => {
                console.log(res);
            }).catch(err => {
                console.log(err);
            })
            await setDoc(doc(firestoredb, "Users", user.uid), {
                uid: user.uid,
                email: email,
                isApproved: true,
                isAdmin: false,
                firstName: "",
                lastName: "",
                dateOfBirth: date,
                phoneNumber: "",
                bindedWallet: ""

            })
                .then((res) => {
                    // signOut(auth);
                    // sendEmailVerification(user).then(() => {
                    //   // Email verification sent!
                    //   // ...
                    //   toast.success("Email Verfication sent!", {
                    //     toastId: "userAdded",
                    //   });
                    localStorage.isSignupSuccess = true;
                    console.log(user);
                    let userData = {
                        email: user.email,
                        name: user.displayName,
                        uid: user.uid,
                    };
                    const jsonString = JSON.stringify(userData);
                    localStorage.setItem("tuxnftuser", jsonString);
                    toast("Signup success");
                    // window.location.reload(false);
                    signOut(auth)
                        .then(() => {
                            console.log("User signed out successfully.");
                        })
                        .catch((error) => {
                            console.log("Error signing out:", error);
                        });
                    // });
                })
                .catch(function (error) {
                    console.log(error);
                    return false;
                });
        })
        .catch((error) => {
            // An error occurred
            console.log(error);

            if (error == "FirebaseError: Firebase: Error (auth/email-already-in-use).") {
                toast("This Email is already Registered")
                console.log("test");
            }
            return false;
        });
}
const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        toast("Password reset link sent!", { toastId: "passowrdresetlnksent" });
        window.location.reload()
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};
const logout = () => {
    signOut(auth);
};


export {
    auth,
    app,
    storage,
    firestoredb,
    secondaryAuth,
    signInWithGoogle,
    logInWithEmailAndPassword,
    registerWithEmailAndPassword,
    sendPasswordReset,
    logout,
};